'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function propagatePropsToChildren(children, newProps) {
	return _react2.default.Children.map(children, function (child, index) {
		if (child) {
			var childProps = {};

			if (_react2.default.isValidElement(child)) {
				childProps = newProps;
				childProps.position = index;
			}

			//Don't propagate to HTML elements (e.g. div)
			if (child.props && typeof child.type !== 'string') {
				return _react2.default.cloneElement(child, childProps);
			}

			return child;
		}
	});
}

exports.default = propagatePropsToChildren;